import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { CommonService } from "@services/common.service";

@Component({
    selector: "app-cms",
    templateUrl: "./cms.component.html",
    styleUrls: ["./cms.component.scss"],
    standalone: false
})
export class CMSPageComponent implements OnInit {
  constructor(private router: Router, public commonService: CommonService) {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
  }

  public accessAllowed: boolean = true;
  public toggleRefresh: any = null;

  ngOnInit(): void {}
}
